module.exports = __webpack_public_path__ + "media/forum/share-forum-post-logo-dark-b52b665f.png";